import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchTransactionHistory = createAsyncThunk(
  'transactionHistory/fetch',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/transaction_history',
      method: 'GET'
    })

    if (!success) {
      return rejectWithValue(response)
    }

    return response
  }
)
